import { useState } from "react";
import { QrCode } from "lucide-react";
import { customerCustomFetch } from "@workspace/api-client-react";
import { LerQrDaMesa } from "@/components/pdv/LerQrDaMesa";
import { nomeDaMesa } from "@/lib/mesa";

// «Link público apenas pela Mesa/Comanda» (Pedro, 31/10/2026, opção B): sem o QR, a vitrine mostra só o nome da loja e o
// botão. A câmera lê o QR (o mesmo leitor das Comandas), a rota pública confere, e a página abre como quem leu o QR pelo
// celular. QR de outra loja ou que não vale mais: o erro fica embaixo da câmera, que segue aberta.
export function SoPeloQr({
  slug,
  storeName,
  logoUrl,
  colorPrimary,
  porCliente,
  invalida,
}: {
  slug: string;
  storeName: string;
  logoUrl?: string | null;
  colorPrimary?: string | null;
  porCliente: boolean;
  /** O QR que trouxe a pessoa até aqui não vale mais. */
  invalida: boolean;
}) {
  const [lendo, setLendo] = useState(false);
  const nome = nomeDaMesa(porCliente);
  const Nome = nome === "comanda" ? "Comanda" : "Mesa";
  const cor = colorPrimary || "#DC2626";
  const ler = async (texto: string): Promise<string | null> => {
    const outro = `Esse QR code não é de uma ${nome} desta loja.`;
    let url: URL;
    try {
      url = new URL(texto, window.location.origin);
    } catch {
      return outro;
    }
    const mesa = url.searchParams.get("mesa");
    const t = url.searchParams.get("t");
    if (!mesa || !t || !url.pathname.replace(/\/+$/, "").endsWith(`/loja/${slug}`)) return outro;
    try {
      await customerCustomFetch(`/api/catalog/${slug}/mesa?mesa=${encodeURIComponent(mesa)}&t=${encodeURIComponent(t)}`);
    } catch {
      return `Esse QR code não vale mais. Peça outro ao atendente.`;
    }
    window.location.assign(`${window.location.pathname}?mesa=${encodeURIComponent(mesa)}&t=${encodeURIComponent(t)}`);
    return null;
  };
  return (
    <div className="flex min-h-[100svh] items-center justify-center p-4" style={{ backgroundColor: `${cor}08` }} data-testid="vitrine-so-pelo-qr">
      <div className="w-full max-w-sm rounded-2xl bg-white p-8 text-center shadow-xl" style={{ borderTop: `4px solid ${cor}` }}>
        {logoUrl && <img src={logoUrl} alt={storeName} className="mx-auto mb-4 h-20 w-20 rounded-2xl object-cover shadow-sm" />}
        <h1 className="text-2xl font-bold text-gray-900">{storeName}</h1>
        <p className="mt-2 text-sm leading-relaxed text-gray-500">
          {invalida ? `Esse QR code não vale mais. Leia o QR code da sua ${nome}.` : `Os pedidos são feitos pelo QR code da ${nome}.`}
        </p>
        <button
          type="button"
          onClick={() => setLendo(true)}
          className="mt-6 inline-flex h-12 w-full items-center justify-center gap-2 rounded-xl px-4 text-base font-semibold text-white shadow-sm"
          style={{ backgroundColor: cor }}
          data-testid="vitrine-ler-qr"
        >
          <QrCode className="h-5 w-5" />
          Ler QR code da {Nome}
        </button>
      </div>
      {lendo && <LerQrDaMesa porCliente={porCliente} onLido={ler} onClose={() => setLendo(false)} />}
    </div>
  );
}
